import { EChannelQuality, IEpgTvPacket, ITvPackage } from '~/src/store/reducers/tvPackages';

export const epg2ProfileTvPackage = (data: IEpgTvPacket[]): ITvPackage[] => {
    return data.map(epgPackage => {
        const { id, alias, body, channels, image680x280, price, themes, title, weight } = epgPackage;

        const { channelsCount, channelsCountHd } = channels?.reduce((acc, channel) => {
            acc.channelsCount++;

            channel.quality === EChannelQuality.HD && acc.channelsCountHd++;

            return acc;
        }, {
            channelsCount: 0,
            channelsCountHd: 0,
        });

        return {
            id: +id,
            active: 0,
            alias,
            cost: price,
            channelsCount,
            channelsCountHd,
            description: body,
            image: image680x280,
            name: title,
            tryAndBuy: null,
            channels,
            themes,
            weight,
        };
    });
};
